module.exports = __webpack_public_path__ + "static/img/screen-default.69faf219.png";